export default "__VITE_ASSET__DctPpfRy__"